import React from 'react';
import styles from './css/PowerGrid.module.css';

interface UndergoundElecticalGridProps {
    data: { [key: string]: any };
}

interface GridItemProps {
    value: number;
    unit: string;
    description: string;
}

const formatValue = (value: number) => {
    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}K`;
    }
    if(value % 1 !== 0) {
        return value.toFixed(2);
    }
    return value;
}

const GridItem = ({ value, unit, description }: GridItemProps) => {
    return (
        <div className={styles.gridItem}>
            <div className={styles.headingContainer}>
                <h1 className={styles.unit}>{unit}</h1>
                <h1 className={styles.heading}>{value || 0}</h1>
            </div>
            <p className={styles.description}>{description}</p>
        </div>
    );
};

export const UndergoundElecticalGrid = ({ data }: UndergoundElecticalGridProps) => {
    const gridItems = [
        {
            value: data.transformer_count || 0,
            unit: "",
            description: "שנאים בתחום הקו הכחול"
        },
        {
            value: data.residential_connections_count || 0,
            unit: "",
            description: "חיבורים לבתים בתחום הקו הכחול"
        },
        {
            value: data.lower_line_length_m || 0,
            unit: "m",
            description: "אורך קווי מתח נמוך להטמנה"
        }
    ];

    return (
        <div className={styles.gridContainer}>
            {gridItems.map((item, index) => (
                <GridItem key={index} {...item} />
            ))}
        </div>
    );
}; 